import { getAttributeValue } from "./get-attribute-value";
export var addHappyFoxId = function (spot, group) {
    spot.tabs.forEach(function (tab) {
        tab.configurations.forEach(function (x) {
            if (!x.webFormUrl) {
                return;
            }
            var happyFoxId = getAttributeValue(group, 'meta_happyfoxproductid');
            if (!happyFoxId) {
                return;
            }
            x.webFormUrl += "?support-id=" + happyFoxId;
        });
    });
};
